import { initNavigation } from './navigation/on-page';
import { initShowHideToggles } from './helper/show-hide-toggles';
import { initCarousels } from './components/carousel';
import { initCollapsibles } from './components/collapsible';
import { initHeaderMenu } from './navigation/header-menu';
import { initIntegrations } from '../components/integration';
import { initMediaTextSwitchers } from './components/media-text-switcher';
import { initMenus } from './components/menu';
import { initModals } from './navigation/modal';
import { initConsentManagement } from '../helpers/consent-management.js';
import { initTracking } from '../tracking';
import { initCaptchas } from '../helpers/captchas';
import { initPreload } from '../helpers/preload';
import { initInternationalPhoneInputs } from '../helpers/international-phone-inputs';
import { ConsentFormHandlerFactory } from '../forms/consent-form-handler/ConsentFormHandlerFactory';
import { ConsentFormHandler } from './tracking/ConsentFormHandler';
import { generalCallbacks } from '../form-callbacks/general';
import { initFormHandler } from '../forms/form-handler';
import { callbackCallbacks } from '../form-callbacks/callback';
import { consentCallbacks } from '../form-callbacks/consent';
import { shiftSubdomain } from '../helpers/extract-domain';
import { initSliders } from './components/slider';
import { initTabs } from './components/tabs';
import { initParameterLinks } from '../helpers/parameter-links';
import { initPrefill } from '../forms/prefill';
import { initChat } from '../helpers/chat';
const initializers = [
    initNavigation,
    initTabs,
    initShowHideToggles,
    initCarousels,
    initCollapsibles,
    initHeaderMenu,
    initIntegrations,
    initMediaTextSwitchers,
    initMenus,
    initModals,
    initTracking,
    initConsentManagement,
    initCaptchas,
    initPreload,
    initParameterLinks,
    initPrefill,
    initChat,
    initInternationalPhoneInputs,
];
const initialize = async () => {
    ConsentFormHandlerFactory.getInstance().registerHandler(new ConsentFormHandler());
    const libraryPromises = [];
    initializers.forEach((initializer) => {
        try {
            initializer();
        }
        catch (e) {
            console.log(e);
        }
    });
    if (document.querySelector('.form.quickorder')) {
        if (!document.querySelector('.free-trial-form')) {
            const selectLib = import('../forms/advanced-select');
            selectLib.then((module) => module.initAdvancedSelects());
            libraryPromises.push(selectLib);
        }
        const quickorderFormScript = import('../forms/quickorder');
        quickorderFormScript.then((module) => module.initQuickorder());
        const quickorderFormCallbacks = import('../form-callbacks/quickorder');
        quickorderFormCallbacks.then((module) => Object.assign(window, module.quickorderCallbacks));
        libraryPromises.push(quickorderFormScript);
        libraryPromises.push(quickorderFormCallbacks);
    }
    if (document.querySelector('.free-trial-form')) {
        const advancedSelect = import('../forms/advanced-select');
        const freeTrialForm = import('../forms/free-trial');
        Promise.all([advancedSelect, freeTrialForm]).then(([advancedSelectModule, freeTrialModule]) => {
            advancedSelectModule.initAdvancedSelects();
            freeTrialModule.initFreeTrials();
        });
        const freeTrialCallbacks = import('../form-callbacks/free-trial');
        freeTrialCallbacks.then((module) => Object.assign(window, module.freeTrialCallbacks));
        libraryPromises.push(advancedSelect);
        libraryPromises.push(freeTrialForm);
        libraryPromises.push(freeTrialCallbacks);
    }
    else if (document.querySelector('.free-trial-simple-form')) {
        const freeTrialCallbacks = import('../form-callbacks/free-trial');
        freeTrialCallbacks.then((module) => Object.assign(window, module.freeTrialCallbacks));
        libraryPromises.push(freeTrialCallbacks);
    }
    else if (document.querySelector('.login-form, .forgot-password-form, .reset-password-form')) {
        const login = import('../forms/login');
        const loginCallbacks = import('../form-callbacks/login');
        login.then((module) => module.initLogin());
        loginCallbacks.then((module) => Object.assign(window, module.loginCallbacks));
        libraryPromises.push(login);
        libraryPromises.push(loginCallbacks);
    }
    const sliders = document.querySelectorAll('.component.slider');
    if (sliders.length > 0) {
        const sliderComponent = import('tiny-slider/src/tiny-slider');
        sliderComponent.then((module) => initSliders(module.tns, sliders));
        libraryPromises.push(sliderComponent);
    }
    await Promise.all(libraryPromises);
    window.addLibsLoadedScript = (fn) => fn();
    if (typeof window.libsLoadedScripts === 'object') {
        window.libsLoadedScripts.forEach((fn) => {
            try {
                fn();
            }
            catch (e) {
                console.error(e);
            }
        });
    }
};
initFormHandler();
initialize();
Object.assign(window, generalCallbacks, callbackCallbacks, consentCallbacks);
window.shiftSubdomain = shiftSubdomain;
